// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2upmj","footer":"ReportModalFilter_footer__1V3dg"};